import React from "react";
import Blocker from "../../../../Misc/Blocker";
import CrumbsProvider from "../../../../Misc/CrumbsProvider";
import WorkflowTree from "./WorkflowTree";
import WorkflowDetail from "./WorkflowDetail";
import Searchbox from "../../../../Misc/Searchbox";
import Scrollpane from "../../../../Misc/Scrollpane";

export default class Workflow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      activeItem: false,
      treeKey: "",
      textSearchValue: "",
    };
  }

  navigate = (id) => {
    this.setState({ activeItem: id });
  };

  finish = (result = {}) => {
    if (result["id"]) {
      let treeKey = `${result["label"]}${result["id"]}${result["parent"]}`;
      this.setState({ activeItem: String(result["id"]), treeKey });
    } else {
      this.setState({ activeItem: false, treeKey: "" });
    }
  };

  handleSearch = (textSearchValue) => {
    this.setState({ textSearchValue });
  };

  render() {
    return (
      <>
        <CrumbsProvider title="Документооборот" link="/admin/workflow" />
        <div className="row h-100">
          <div className="col-lg-3 border-right no-print">
            <Scrollpane>
              <Blocker spinnerFixed hAuto on={this.state.pending}>
                <div className="mb-4">
                  <Searchbox
                    onSearch={this.handleSearch}
                    defaultText={this.state.textSearchValue}
                  />
                </div>

                <WorkflowTree
                  textSearchValue={this.state.textSearchValue}
                  activeItem={this.state.activeItem}
                  onFinish={this.finish}
                  onChange={this.navigate}
                  key={this.state.treeKey}
                />
              </Blocker>
            </Scrollpane>
          </div>
          <div className="col h-100">
            <Scrollpane>
              <Blocker spinnerFixed hAuto on={this.state.pending}>
                <WorkflowDetail
                  key={this.state.activeItem}
                  activeItem={this.state.activeItem}
                  onFinish={this.finish}
                  items={this.state.items}
                />
              </Blocker>
            </Scrollpane>
          </div>
        </div>
      </>
    );
  }
}
